import {
	PropsWithChildren,
	Children,
	ReactElement,
	cloneElement,
	isValidElement,
	Dispatch,
	SetStateAction,
	useCallback,
	useRef
} from 'react';
import styles from './PagedDialog.module.scss';
import { Scrollbar } from '@components';

type TPagesProps = {
	context?: {
		activeMenu: number;
		setActiveMenu: Dispatch<SetStateAction<number>>;
		activeSubMenu: number;
		setActiveSubMenu: Dispatch<SetStateAction<number>>;
	}
}

export const Pages = (props: PropsWithChildren<TPagesProps>) => {
	const { children } = props;
	const pagesRef = useRef<HTMLDivElement>(null);
	const getItems = useCallback(() => {
		const pageItems: ReactElement[] = [];
		Children.toArray(children).forEach((Child, i) => {
			if (isValidElement(Child) && ['function', 'object'].includes(typeof Child.type)) {
				pageItems.push(cloneElement(Child as ReactElement<any>, { pagesRef, key: i }));
			} else {
				pageItems.push(Child as ReactElement);
			}
		});
		return pageItems;
	}, [children, pagesRef]);
	return (
		<div className={styles.pages} ref={pagesRef}>
			<Scrollbar />
			{getItems()}
		</div>
	);
}
Pages.displayName = 'Pages';
